import '../../../base_builders/vertical/rcp/rcp_base_vendor_builder.js';

import Adapex from '../../../../assets/js/Ads/Adapex.js';
Adapex();

import {init_taboola_articles} from '../../../../assets/js/Ads/TaboolaLib';
init_taboola_articles();